import { useAlertConfig } from '../../../../../hooks';
import { useAddMessageStep } from './useAddMessageStep';
import { useAddRecipientsStep } from './useAddRecipientsStep';
import { useDefineDeliveryStep } from './useDefineDeliveryStep';
export function useAlertWizardSteps(alert, mode, shouldGenerateUniqueIdentifier) {
    const addMessageStep = useAddMessageStep();
    const { onGetAdditionalWizardStep } = useAlertConfig();
    const addRecipientsStep = useAddRecipientsStep(mode, {
        hideHeader: false,
        paddingTop: 36,
        mode: 'edit',
    }, alert.followUp);
    const defineDeliveryStep = useDefineDeliveryStep(alert, shouldGenerateUniqueIdentifier);
    const wizardSteps = [defineDeliveryStep, addMessageStep, addRecipientsStep];
    const additionalWizardStep = onGetAdditionalWizardStep ? onGetAdditionalWizardStep({ mode: 'edit' }) : undefined;
    if (additionalWizardStep) {
        wizardSteps.splice(2, 0, {
            label: additionalWizardStep.label,
            form: {
                type: 'form',
                children: [
                    {
                        type: 'form.panel',
                        key: 'customAlertData',
                        children: additionalWizardStep.formChildren,
                    },
                ],
            },
        });
    }
    return wizardSteps;
}
